import { render } from "./ExpirationField.vue?vue&type=template&id=6af8fb9e&scoped=true"
import script from "./ExpirationField.vue?vue&type=script&lang=js"
export * from "./ExpirationField.vue?vue&type=script&lang=js"

import "./ExpirationField.vue?vue&type=style&index=0&id=6af8fb9e&scoped=true&lang=css"

import exportComponent from "/home/gp/git/git.glitchedpolygons.ch/locales.glitchedpolygons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af8fb9e"]])

export default __exports__